import { FC, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { clsx } from 'clsx'

import styles from './styles.module.scss'

const TIMER = 6000

let idInterval: ReturnType<typeof setTimeout>
let idTimeOut: ReturnType<typeof setTimeout>

const ADVICES = [
  'advices.advice_one',
  'advices.advice_two',
  'advices.advice_three',
  'advices.advice_four',
  'advices.advice_five',
  'advices.advice_six',
  'advices.advice_seven',
  'advices.advice_eight',
  'advices.advice_nine',
  'advices.advice_ten',
  'advices.advice_eleven',
  'advices.advice_twelve',
  'advices.advice_thirteen',
  'advices.advice_fourteen',
  'advices.advice_fifteen',
  'advices.advice_sixteen',
  'advices.advice_seventeen',
  'advices.advice_eighteen',
  'advices.advice_nineteen',
  'advices.advice_twenty',
  'advices.advice_twenty_one',
  'advices.advice_twenty_two',
  'advices.advice_twenty_three',
  'advices.advice_twenty_four',
  'advices.advice_twenty_five',
  'advices.advice_twenty_six',
  'advices.advice_twenty_seven',
  'advices.advice_twenty_eight',
  'advices.advice_twenty_nine',
  'advices.advice_thirty',
  'advices.advice_thirty_one',
  'advices.advice_thirty_two',
  'advices.advice_thirty_three',
  'advices.advice_thirty_four',
  'advices.advice_thirty_five',
  'advices.advice_thirty_six',
  'advices.advice_thirty_seven',
]

export const AppAdviceText: FC = () => {
  const { t } = useTranslation()

  const getRandomAdvice = () => {
    return ADVICES[Math.floor(Math.random() * ADVICES.length - 1) + 1]
  }

  const startShowInterval = () => {
    idInterval = setInterval(() => {
      startAnimation()
    }, TIMER)
  }

  const startAnimation = () => {
    setAdvice(getRandomAdvice())

    setIsClear(false)
    clearTimeout(idTimeOut)

    idTimeOut = setTimeout(() => {
      setIsClear(true)
    }, TIMER - 1000)
  }

  const [advice, setAdvice] = useState<string>('')
  const [isClear, setIsClear] = useState<boolean>(false)

  useEffect(() => {
    startAnimation()

    startShowInterval()

    return () => {
      clearInterval(idInterval)
      clearTimeout(idTimeOut)
    }
  }, [])

  return (
    <div className={styles.container}>
      <p className={clsx(isClear && styles.close)}>{t(advice)}</p>
    </div>
  )
}
